import React from 'react'
import CargoAddForm from './CargoAddPage'

function AddPage({ history, showNotification }) {
  return <CargoAddForm history={history} showNotification={showNotification} />
}

export default AddPage
